import { gql, useQuery } from '@apollo/client'

import {
  RecommendCollectionConnectionFragmentDoc,
  RecommendCollectionsQuery,
  RecommendCollectionsQueryVariables,
} from '@/clients/utoniq-core/schema'
import { config } from '@/config'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ artistId?: string }>()
  const { data, loading, fetchMore } = useQuery<
    RecommendCollectionsQuery,
    RecommendCollectionsQueryVariables
  >(QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: { artistId: router.query.artistId ?? config.artistId },
  })

  return {
    state: {
      loading,
      hasNextPage: !!data?.recentlyViewedCollections?.pageInfo.hasNextPage,
      items: data?.recentlyViewedCollections ?? null,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            pageInput: {
              cursor: data?.recentlyViewedCollections?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query RecommendCollections($pageInput: PageInput, $artistId: String) {
    recentlyViewedCollections(pageInput: $pageInput, artistId: $artistId) {
      ...RecommendCollectionConnection
    }
  }
  ${RecommendCollectionConnectionFragmentDoc}
`
